module.exports = __webpack_public_path__ + "img/phone-1.e7b7482b.jpg";